;(function(){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Store = require('../../js/Store');

var _Store2 = _interopRequireDefault(_Store);

var _counter = require('../counter/counter.vue');

var _counter2 = _interopRequireDefault(_counter);

var _rating = require('../rating/rating.vue');

var _rating2 = _interopRequireDefault(_rating);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        product: {
            type: Object
        },
        position: {
            type: String
        }
    },
    data: function data() {
        return {
            isLoading: false
        };
    },

    store: _Store2.default,
    components: {
        counter: _counter2.default,
        rating: _rating2.default
    },
    computed: {
        total: function total() {
            return this.product.amount * this.product.cost;
        }
    },
    methods: {
        remove: function remove(id) {
            var _this = this;

            this.isLoading = true;
            _Store2.default.dispatch('removeProduct', id).then(function () {
                _this.isLoading = false;
            });
        },
        updateAmount: function updateAmount(_ref) {
            var _this2 = this;

            var amount = _ref.amount;

            this.product.amount = amount;
            this.isLoading = true;
            _Store2.default.dispatch('updateProductAmount', {
                id: this.product.id,
                amount: amount
            }).then(function () {
                _this2.isLoading = false;
            });
        }
    }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"product-item",class:[_vm.position, _vm.isLoading ? "is-loading" : "" ],attrs:{"data-id":_vm.product.id}},[_c('img',{staticClass:"product-item__img",attrs:{"src":_vm.product.img,"alt":_vm.product.title}}),_c('div',{staticClass:"product-item__body"},[_c('header',{staticClass:"product-item__header"},[_c('h3',{staticClass:"product-item__title"},[_c('a',{staticClass:"product-item__link",attrs:{"href":_vm.product.url,"title":_vm.product.title}},[_vm._v(_vm._s(_vm.product.title))])]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.position == "in-cart"),expression:"position == \"in-cart\""}],staticClass:"product-item__rating"},[_c('rating',{attrs:{"rating":_vm.product.rating}})],1)]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.position == "in-cart"),expression:"position == \"in-cart\""}],staticClass:"product-item__price"},[_vm._v(_vm._s(_vm._f("price")(_vm.product.cost)))]),_c('div',{staticClass:"product-item__counter"},[_c('counter',{attrs:{"update-amount":_vm.updateAmount,"current-amount":_vm.product.amount,"max-value":_vm.product.max || 10,"id":_vm.product.id}})],1),_c('div',{staticClass:"product-item__price is-total"},[_vm._v(_vm._s(_vm._f("price")(_vm.total)))]),_c('button',{staticClass:"product-item__remove",attrs:{"title":"Удалить","area-label":"Удалить","type":"button"},on:{"click":function($event){return _vm.remove(_vm.product.id)}}})])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2d6361ef", __vue__options__)
  } else {
    hotAPI.reload("data-v-2d6361ef", __vue__options__)
  }
})()}